import React from 'react';

const ArticleList = ({ articles }) => {
  return (
    <div className="article-list">
      {articles.map((article, index) => (
        <div key={index} className="article-item">
          <div className="article-thumb">
            <img
              src={article.image_thumb || '/default-thumb.jpg'}
              alt={article.article_title || 'Untitled'}
            />
          </div>
          <div className="article-content">
            <p className="article-type">
              {article.content_type === 'igtt' ? 'video' : article.content_type}
            </p>
            <div className="title-row">
              <h3 className="article-title">{article.article_title || 'Untitled'}</h3>
              <a 
                href={`/${article.content_type === 'igtt' ? 'video' : article.content_type}/${article.slug}`} 
                className="article-link more-link"
              >
                More...
              </a>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ArticleList;